import {
    Dashboard as DashboardIcon,
    AdminPanelSettings as AdminIcon,
    People as UsersIcon,
    Settings as SettingsIcon,
    Category as CategoryIcon,
    Inventory2 as ProductIcon,
    ConfirmationNumber as CouponIcon,
    Article as CmsIcon,
    Star as StarIcon,
    Notifications as NotificationsIcon,
    Warehouse as StockIcon,
    ReceiptLong as TaxIcon,
    LocalShipping as DeliveryIcon,
    PlaylistAddCheck as CategoryValueIcon,
    ShoppingBag as OrderIcon,
    Payment as PaymentIcon,
    ViewCarousel as BannerIcon,
    Collections as CollectionsIcon,
    Sync as SyncIcon,
    ErrorOutline as ErrorLogIcon
} from '@mui/icons-material';
import React from 'react';

export interface MenuItem {
    id: string;
    title: string;
    icon?: React.ReactNode;
    link: string;
    permission: string;
}

export interface MenuGroup {
    label: string;
    items: MenuItem[];
}

export const MENU_ITEMS: MenuGroup[] = [
    {
        label: 'Dashboard',
        items: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                icon: React.createElement(DashboardIcon),
                link: '/dashboard',
                permission: 'dashboard'
            }
        ]
    },
    {
        label: 'Orders',
        items: [
            {
                id: 'orders',
                title: 'Orders',
                icon: React.createElement(OrderIcon),
                link: '/orders',
                permission: 'orders'
            },
            {
                id: 'delivery-proof',
                title: 'Delivery Proof',
                icon: React.createElement(DeliveryIcon),
                link: '/delivery-proof',
                permission: 'orders'
            },
            {
                id: 'payments',
                title: 'Payments',
                icon: React.createElement(PaymentIcon),
                link: '/payments',
                permission: 'orders'
            }
        ]
    },
    {
        label: 'GoFrugal',
        items: [
            {
                id: 'gofrugal-sync',
                title: 'GoFrugal Sync',
                icon: React.createElement(SyncIcon),
                link: '/gofrugal-sync',
                permission: 'orders'
            },
            {
                id: 'gofrugal-error-logs',
                title: 'Error Logs',
                icon: React.createElement(ErrorLogIcon),
                link: '/gofrugal-error-logs',
                permission: 'orders'
            }
        ]
    },
    {
        label: 'Users & Admins',
        items: [
            {
                id: 'admin',
                title: 'Admin',
                icon: React.createElement(AdminIcon),
                link: '/admin',
                permission: 'admin'
            },
            {
                id: 'users',
                title: 'Users',
                icon: React.createElement(UsersIcon),
                link: '/users',
                permission: 'users'
            }
        ]
    },
    {
        label: 'Catalog Management',
        items: [
            {
                id: 'category',
                title: 'Category',
                icon: React.createElement(CategoryIcon),
                link: '/category',
                permission: 'category'
            },
            {
                id: 'category-value',
                title: 'Category Values',
                icon: React.createElement(CategoryValueIcon),
                link: '/category-value',
                permission: 'categoryValue'
            },
            {
                id: 'product',
                title: 'Products',
                icon: React.createElement(ProductIcon),
                link: '/product',
                permission: 'product'
            },
            {
                id: 'collections',
                title: 'Collections',
                icon: React.createElement(CollectionsIcon),
                link: '/collections',
                permission: 'collection'
            }
        ]
    },
    {
        label: 'Inventory & Rating',
        items: [
            {
                id: 'stocks',
                title: 'Stocks',
                icon: React.createElement(StockIcon),
                link: '/stock',
                permission: 'stock'
            },
            {
                id: 'product-ratings',
                title: 'Product Ratings',
                icon: React.createElement(StarIcon),
                link: '/product-ratings',
                permission: 'product-ratings'
            }
        ]
    },
    {
        label: 'Promotions & Content',
        items: [
            {
                id: 'coupons',
                title: 'Coupons',
                icon: React.createElement(CouponIcon),
                link: '/coupons',
                permission: 'coupons'
            },
            {
                id: 'cms',
                title: 'CMS Pages',
                icon: React.createElement(CmsIcon),
                link: '/cms',
                permission: 'cms'
            },
            {
                id: 'notifications',
                title: 'Notifications',
                icon: React.createElement(NotificationsIcon),
                link: '/notifications',
                permission: 'notifications'
            },
            {
                id: 'banners',
                title: 'Banners',
                icon: React.createElement(BannerIcon),
                link: '/banners',
                permission: 'banner.list'
            }
        ]
    },
    {
        label: 'Rules & Settings',
        items: [
            {
                id: 'tax',
                title: 'Taxes',
                icon: React.createElement(TaxIcon),
                link: '/tax',
                permission: 'tax'
            },
            {
                id: 'delivery-charge',
                title: 'Delivery Charges',
                icon: React.createElement(DeliveryIcon),
                link: '/delivery-charge',
                permission: 'deliveryCharge'
            },
            {
                id: 'settings',
                title: 'Settings',
                icon: React.createElement(SettingsIcon),
                link: '/settings',
                permission: 'settings'
            }
        ]
    }
];
